import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.define-properties";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
export var AppContext = function AppContext(_contexts) {
  var _this = this;

  _classCallCheck(this, AppContext);

  _defineProperty(this, "add", function (contexts) {
    contexts.forEach(function (context) {
      var name = '';
      if (typeof context === 'string') name = context;else name = context.name;
      _this.contexts[name] = /*#__PURE__*/React.createContext(context.value);
    });
  });

  var appContexts = {};
  this.contexts = appContexts;
  if (_contexts) this.add(_contexts);

  this.Providers = function (_ref) {
    var contexts = _ref.contexts,
        children = _ref.children;
    return contexts.reduce(function (children, _ref2) {
      var name = _ref2.name,
          value = _ref2.value;
      var context = appContexts[name];
      var Provider = context && context.Provider;
      return Provider && /*#__PURE__*/React.createElement(Provider, {
        value: value
      }, children);
    }, children);
  };

  function getConsumers(contexts, children, index, valuesObject) {
    var item = contexts[index];
    var contextName = '';
    if (typeof item === 'string') contextName = item;else contextName = item.name;
    var context = appContexts[contextName];
    var Consumer = context && context.Consumer;

    if (index === 0) {
      return /*#__PURE__*/React.createElement(Consumer, null, function (value) {
        return children(_objectSpread(_defineProperty({}, contextName, value), valuesObject));
      });
    } else {
      var nextIndex = index - 1;
      return /*#__PURE__*/React.createElement(Consumer, null, function (value) {
        valuesObject[contextName] = value;
        return getConsumers(contexts, children, nextIndex, valuesObject);
      });
    }
  }

  this.Consumers = function (_ref3) {
    var contexts = _ref3.contexts,
        children = _ref3.children;
    return getConsumers(contexts, children, contexts.length - 1, {});
  };
};
export default AppContext;